import classNames from 'classnames';
import * as React from 'react';
import { List } from '../List/List';
import type { UnionAwareOmit } from '~/Partials/Utils/typeUtils';
import type { AccordionItemProps } from './AccordionItem';
import { AccordionItem } from './AccordionItem';
import styles from './AccordionList.module.css';

export type AccordionListItemProps = UnionAwareOmit<
    AccordionItemProps,
    'variant' | 'color' | 'contentSpacing' | 'externallyExpanded' | 'className'
>;

export interface AccordionListProps extends Pick<AccordionItemProps, 'color' | 'variant' | 'contentSpacing'> {
    accordions: AccordionListItemProps[];
    expandedAreaIds?: string[];
    className?: string;
    itemClassName?: string;
}

export const AccordionList: React.FC<React.PropsWithChildren<AccordionListProps>> = props => {
    const {
        accordions,
        expandedAreaIds,
        className,
        itemClassName,
        variant = 'solid',
        color = 'grey',
        contentSpacing = 'fullWidth',
    } = props;

    function mapModelToElements(item: AccordionListItemProps, index: number) {
        const externallyExpand = !!expandedAreaIds && !!item.index && expandedAreaIds.indexOf(item.index) > -1;

        return (
            <li className={styles.Item} key={index}>
                <AccordionItem
                    {...item}
                    className={itemClassName}
                    variant={variant}
                    color={color}
                    contentSpacing={contentSpacing}
                    externallyExpanded={externallyExpand}
                >
                    {item.children}
                </AccordionItem>
            </li>
        );
    }

    return (
        <List
            className={classNames(styles.AccordionList, className)}
            items={accordions}
            renderItem={mapModelToElements}
        />
    );
};
